package es.subastia.ui.theme

import androidx.compose.runtime.Composable

@Composable
actual fun SystemAppearance(isDark: Boolean) {
}
